<template>
  <EditorButton :title="$t('link')">
    <template v-slot:trigger="{ hide, show }">
      <MPopover
        ref="popover"
        placement="bottomRight"
        :overlay-style="{ width: '300px' }"
        @show="handlePopoverShow"
      >
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="small-icon-button"
            :style="buttonStyle"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
        <FlotoForm @submit="handleFormSubmit">
          <FlotoFormItem
            ref="input"
            v-model="url"
            :label="$tc('link')"
            rules="required|url"
            placeholder="http://example.com"
            @keydown.esc="hideMenu"
          />
          <template v-slot:submit>
            <div class="text-right">
              <MButton type="submit" size="small" class="mr-2">
                {{ $t('link') }}
              </MButton>
              <MButton
                v-if="link"
                size="small"
                variant="default"
                class="mr-2"
                @click="removeLink"
              >
                {{ $t('remove') }}
              </MButton>
              <MButton size="small" variant="default" @click="hideMenu">
                {{ $t('cancel') }}
              </MButton>
            </div>
          </template>
        </FlotoForm>
      </MPopover>
    </template>
  </EditorButton>
</template>

<script>
import EditorButton from './editor-button'
export default {
  name: 'LinkButton',
  components: { EditorButton },
  props: {
    link: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      url: '',
    }
  },
  computed: {
    buttonStyle() {
      if (this.disabled) {
        return { pointerEvents: 'none', opacity: 0.5 }
      }
      return {}
    },
  },
  watch: {
    link(newValue) {
      this.url = newValue
    },
  },
  methods: {
    handlePopoverShow() {
      setTimeout(() => {
        this.$refs.input.focus()
      }, 250)
    },
    handleFormSubmit() {
      this.$emit('add', this.url)
      this.hideMenu()
    },
    removeLink() {
      this.$emit('remove')
      this.hideMenu()
    },
    hideMenu() {
      this.$emit('hide')
      this.$refs.popover.hide()
    },
  },
}
</script>
